'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_39642e22 = {"bubble":"Tooltip_module_bubble__31133942","arrow":"Tooltip_module_arrow__31133942","container":"Tooltip_module_container__31133942","close":"Tooltip_module_close__31133942","outline-none":"Tooltip_module_outlineNone__31133942"};
require("../../../assets/cjs/components/Tooltip/src/Tooltip~CDDeW255.css");

exports.default = modules_39642e22;
//# sourceMappingURL=Tooltip.module.less.js.map
